import { ROUTES } from '~/constants/routes';
import i18n from '~/locales/i18next';
import { JUDGEMENT_STATUS } from '~/common/constants';

export const APP_ORIGIN = process.env.REACT_APP_ORIGINS_GMOASK_FRONT;

const NODE_ENVS = {
  // DEV: 'development',
  // PROD: 'production',
  TEST: 'test',
};

export const LOGGER_ENABLED =
  process.env.REACT_APP_LOGGER_ENABLED === 'true' && process.env.NODE_ENV !== NODE_ENVS.TEST; // jestの時はloggerをdisabledにする

// 使用しているsessionStorageリスト。ログアウト時に値は全てクリアされる。
export const SESSION_STORAGES = {
  ADMIN_UNAUTHORIZED_ERROR_REFERRER: 'adminUnauthorizedErrorReferrer', // 管理者ログイン後の遷移先
  USER_UNAUTHORIZED_ERROR_REFERRER: 'userUnauthorizedErrorReferrer', // ユーザログイン後の遷移先
  SURVEY_SEARCH_BOX_CONDITIONS: 'surveySearchBoxConditions', // 調査検索条件の保持
};

// 使用しているlocalStorageリスト。ログアウトと401エラー時に値は全てクリアされる。
export const LOCAL_STORAGES = {
  ADMIN_ROLES: 'adminRoles', // ログイン管理者のロール一覧,
  ORIGINAL_FORM: 'originalForm',
};

// TODO: change all callee to typescript constants.
export const SURVEY_STATUSES = {
  REGISTERING: 1,
  UNDER_REVIEW: 2,
  APPROVED: 3,
  COLLECTING: 4,
  COMPLETED: 6,
  REJECTED: 7,
  CANCELED: 8,
};

export const SURVEY_STATUSES_NAMES = {
  [SURVEY_STATUSES.REGISTERING]: i18n.t('myPage.surveySearchBox.statusName.1'),
  [SURVEY_STATUSES.UNDER_REVIEW]: i18n.t('myPage.surveySearchBox.statusName.2'),
  [SURVEY_STATUSES.APPROVED]: i18n.t('myPage.surveySearchBox.statusName.3'),
  [SURVEY_STATUSES.COLLECTING]: i18n.t('myPage.surveySearchBox.statusName.4'),
  [SURVEY_STATUSES.COMPLETED]: i18n.t('myPage.surveySearchBox.statusName.6'),
  [SURVEY_STATUSES.REJECTED]: i18n.t('myPage.surveySearchBox.statusName.7'),
  [SURVEY_STATUSES.CANCELED]: i18n.t('myPage.surveySearchBox.statusName.8'),
};

// プログレスバー用のラベル定義
export const PROGRESS_TRACKER_LABELS = {
  USER_REGISTRATION: [
    'progressTracker.userRegistration.signup',
    'progressTracker.userRegistration.confirm',
    'progressTracker.userRegistration.complete',
  ],
  SURVEY: [
    'progressTracker.survey.delivery',
    'progressTracker.survey.apply',
    'progressTracker.survey.complete',
  ],
};

export const PROGRESS_TYPE = {
  USER_REGISTRATION: 'USER_REGISTRATION',
  SURVEY: 'SURVEY',
};

// URLパスとプログレスバーの進捗度のマップ（ユーザー登録用）
export const USER_REGISTRATION_PROGRESSES = {
  [ROUTES.USER.SIGNUP]: 0,
  [ROUTES.USER.SIGNUP_CONFIRM]: 1,
  [ROUTES.USER.SIGNUP_COMPLETED]: 1,
  [ROUTES.USER.SIGNUP_VERIFY_COMPLETED]: 2,
};

// URLパスとプログレスバーの進捗度のマップ（アンケート用）
export const SURVEY_PROGRESSES = {
  [ROUTES.USER.SURVEY_REGISTER_TYPE_SELECTION]: 0,
  [ROUTES.USER.SURVEY]: 0,
  [ROUTES.USER.SURVEY_APPLY]: 1,
  [ROUTES.USER.SURVEY_APPLY_COMPLETED]: 2,
};

export const DELIVERY_DATE = {
  DEFAULT_BUSINESS_DAYS: 2, // その日の何営業日後をデフォルトの配信日とするか
};

export const DELIVERY_TIME = {
  DEFAULT: '08:00',
  FORMAT: 'HH:mm',
  MIN_STEP: 30,
};

export const LIMIT_TOTAL_AMOUNT = {
  MIN: 11000,
  MAX: 550000,
};

export const LIMIT_TARGET_SAMPLES_TOTAL = {
  MAX: 99999,
};

// NOTE: 数字区切りのカンマの引数として使用。ないとブラウザデフォルトの言語の区切り仕様になる
export const LOCALE_STRING = {
  ja: 'ja-JP',
};

export const SPECIAL_PANEL_DISPLAY_SETTING_IDS = {
  V1: 1,
  V2: 2,
};

export const SPEPANE_AMSWER_LIST = {
  [SPECIAL_PANEL_DISPLAY_SETTING_IDS.V1]: {
    isAllChecked: i18n.t('specialCondition.isAllChecked'), // すべて選択
    '392_universal_data-B28-1': i18n.t('specialCondition.jobGroup.B28-1'), // 職種: 営業・企画系
    '392_universal_data-B28-2': i18n.t('specialCondition.jobGroup.B28-2'), // 職種: 事務系
    '392_universal_data-B28-3': i18n.t('specialCondition.jobGroup.B28-3'), // 職種: サービス・販売系
    '392_universal_data-B28-4': i18n.t('specialCondition.jobGroup.B28-4'), // 職種: クリエイティブ系
    '392_universal_data-B28-5': i18n.t('specialCondition.jobGroup.B28-5'), // 職種: 技術系（ソフトウェア・ネットワーク）
    '392_universal_data-B28-6': i18n.t('specialCondition.jobGroup.B28-6'), // 職種: 技術系（電子・電気・機械）
    '392_universal_data-B28-7': i18n.t('specialCondition.jobGroup.B28-7'), // 職種: 技術系（素材・食品・メディカル）
    '392_universal_data-B28-8': i18n.t('specialCondition.jobGroup.B28-8'), // 職種: 技術系（土木・建築）
    '392_universal_data-B28-9': i18n.t('specialCondition.jobGroup.B28-9'), // 職種: 社内情報システム
    '392_universal_data-B28-10': i18n.t('specialCondition.jobGroup.B28-10'), // 職種:  専門職
    '392_universal_data-B28-11': i18n.t('specialCondition.jobGroup.B28-11'), // 職種: その他
    '392_universal_data-B20-1': i18n.t('specialCondition.industry.B20-1'), // 業種: 農業・林業・漁業・鉱業
    '392_universal_data-B20-2': i18n.t('specialCondition.industry.B20-2'), // 業種: 情報通信業
    '392_universal_data-B20-3': i18n.t('specialCondition.industry.B20-3'), // 業種: 建設業
    '392_universal_data-B20-4': i18n.t('specialCondition.industry.B20-4'), // 業種: 製造業
    '392_universal_data-B20-5': i18n.t('specialCondition.industry.B20-5'), // 業種: 電気・ガス・水道業
    '392_universal_data-B20-6': i18n.t('specialCondition.industry.B20-6'), // 業種: 運輸・輸送業
    '392_universal_data-B20-7': i18n.t('specialCondition.industry.B20-7'), // 業種: 流通業・卸売業・小売業
    '392_universal_data-B20-8': i18n.t('specialCondition.industry.B20-8'), // 業種: 金融業（銀行または証券）・保険業
    '392_universal_data-B20-9': i18n.t('specialCondition.industry.B20-9'), // 業種: 不動産業・物品賃貸業
    '392_universal_data-B20-10': i18n.t('specialCondition.industry.B20-10'), // 業種: 宿泊業・飲食店
    '392_universal_data-B20-11': i18n.t('specialCondition.industry.B20-11'), // 業種: 生活関連サービス業・娯楽業
    '392_universal_data-B20-12': i18n.t('specialCondition.industry.B20-12'), // 業種: 教育業
    '392_universal_data-B20-13': i18n.t('specialCondition.industry.B20-13'), // 業種: 医療・福祉
    '392_universal_data-B20-14': i18n.t('specialCondition.industry.B20-14'), // 業種: 出版・印刷業
    '392_universal_data-B20-15': i18n.t('specialCondition.industry.B20-15'), // 業種: メディア・マスコミ・広告業
    '392_universal_data-B20-16': i18n.t('specialCondition.industry.B20-16'), // 業種: マーケットリサーチまたは調査業
    '392_universal_data-B20-17': i18n.t('specialCondition.industry.B20-17'), // 業種: 商社
    '392_universal_data-B20-18': i18n.t('specialCondition.industry.B20-18'), // 業種: 非営利団体またはNPO
    '392_universal_data-B20-19': i18n.t('specialCondition.industry.B20-19'), // 業種: その他
    '392_universal_data-A5-1': i18n.t('specialCondition.marriageStatus.A5-1'), // 婚姻状況: 未婚（離別・死別を含む）
    '392_universal_data-A5-2': i18n.t('specialCondition.marriageStatus.A5-2'), // 婚姻状況: 既婚
    '392_universal_data-A6-1': i18n.t('specialCondition.childrenStatus.A6-1'), // 子供有無: 無し
    '392_universal_data-A6-2': i18n.t('specialCondition.childrenStatus.A6-2'), // 子供有無: 有り
  },
  [SPECIAL_PANEL_DISPLAY_SETTING_IDS.V2]: {
    isAllChecked: i18n.t('specialCondition.isAllChecked'), // すべて選択
    '392_universal_data-A18-1': i18n.t('specialCondition.jobType.A18-1'),
    '392_universal_data-A18-2': i18n.t('specialCondition.jobType.A18-2'),
    '392_universal_data-A18-3': i18n.t('specialCondition.jobType.A18-3'),
    '392_universal_data-A18-4': i18n.t('specialCondition.jobType.A18-4'),
    '392_universal_data-A18-5': i18n.t('specialCondition.jobType.A18-5'),
    '392_universal_data-A18-6': i18n.t('specialCondition.jobType.A18-6'),
    '392_universal_data-A18-7': i18n.t('specialCondition.jobType.A18-7'),
    '392_universal_data-A18-8': i18n.t('specialCondition.jobType.A18-8'),
    '392_universal_data-A18-9': i18n.t('specialCondition.jobType.A18-9'),
    '392_universal_data-A18-10': i18n.t('specialCondition.jobType.A18-10'),
    '392_universal_data-A18-11': i18n.t('specialCondition.jobType.A18-11'),
    '392_universal_data-A18-12': i18n.t('specialCondition.jobType.A18-12'),
    '392_universal_data-B20-1': i18n.t('specialCondition.industry.B20-1'),
    '392_universal_data-B20-2': i18n.t('specialCondition.industry.B20-2'),
    '392_universal_data-B20-3': i18n.t('specialCondition.industry.B20-3'),
    '392_universal_data-B20-4': i18n.t('specialCondition.industry.B20-4'),
    '392_universal_data-B20-5': i18n.t('specialCondition.industry.B20-5'),
    '392_universal_data-B20-6': i18n.t('specialCondition.industry.B20-6'),
    '392_universal_data-B20-7': i18n.t('specialCondition.industry.B20-7'),
    '392_universal_data-B20-8': i18n.t('specialCondition.industry.B20-8'),
    '392_universal_data-B20-9': i18n.t('specialCondition.industry.B20-9'),
    '392_universal_data-B20-10': i18n.t('specialCondition.industry.B20-10'),
    '392_universal_data-B20-11': i18n.t('specialCondition.industry.B20-11'),
    '392_universal_data-B20-12': i18n.t('specialCondition.industry.B20-12'),
    '392_universal_data-B20-13': i18n.t('specialCondition.industry.B20-13'),
    '392_universal_data-B20-14': i18n.t('specialCondition.industry.B20-14'),
    '392_universal_data-B20-15': i18n.t('specialCondition.industry.B20-15'),
    '392_universal_data-B20-16': i18n.t('specialCondition.industry.B20-16'),
    '392_universal_data-B20-17': i18n.t('specialCondition.industry.B20-17'),
    '392_universal_data-B20-18': i18n.t('specialCondition.industry.B20-18'),
    '392_universal_data-B20-19': i18n.t('specialCondition.industry.B20-19'),
    '392_universal_data-B27-1': i18n.t('specialCondition.numOfWorkers.B27-1'),
    '392_universal_data-B27-2': i18n.t('specialCondition.numOfWorkers.B27-2'),
    '392_universal_data-B27-3': i18n.t('specialCondition.numOfWorkers.B27-3'),
    '392_universal_data-B27-4': i18n.t('specialCondition.numOfWorkers.B27-4'),
    '392_universal_data-B27-5': i18n.t('specialCondition.numOfWorkers.B27-5'),
    '392_universal_data-B27-6': i18n.t('specialCondition.numOfWorkers.B27-6'),
    '392_universal_data-B27-7': i18n.t('specialCondition.numOfWorkers.B27-7'),
    '392_universal_data-B27-8': i18n.t('specialCondition.numOfWorkers.B27-8'),
    '392_universal_data-B27-9': i18n.t('specialCondition.numOfWorkers.B27-9'),
    '392_universal_data-B27-10': i18n.t('specialCondition.numOfWorkers.B27-10'),
    '392_universal_data-B27-11': i18n.t('specialCondition.numOfWorkers.B27-11'),
    '392_universal_data-B35-1': i18n.t('specialCondition.jobPosition.B35-1'),
    '392_universal_data-B35-2': i18n.t('specialCondition.jobPosition.B35-2'),
    '392_universal_data-B35-3': i18n.t('specialCondition.jobPosition.B35-3'),
    '392_universal_data-B35-4': i18n.t('specialCondition.jobPosition.B35-4'),
    '392_universal_data-B35-5': i18n.t('specialCondition.jobPosition.B35-5'),
    '392_universal_data-B35-6': i18n.t('specialCondition.jobPosition.B35-6'),
    '392_universal_data-B35-7': i18n.t('specialCondition.jobPosition.B35-7'),
    '392_universal_data-B35-8': i18n.t('specialCondition.jobPosition.B35-8'),
    '392_universal_data-B35-9': i18n.t('specialCondition.jobPosition.B35-9'),
    '392_universal_data-B35-10': i18n.t('specialCondition.jobPosition.B35-10'),
    '392_universal_data-B35-11': i18n.t('specialCondition.jobPosition.B35-11'),
    '392_universal_data-B35-12': i18n.t('specialCondition.jobPosition.B35-12'),
    '392_universal_data-B35-13': i18n.t('specialCondition.jobPosition.B35-13'),
    '392_universal_data-B35-14': i18n.t('specialCondition.jobPosition.B35-14'),
    '392_universal_data-A16-1': i18n.t('specialCondition.householdIncome.A16-1'),
    '392_universal_data-A16-2': i18n.t('specialCondition.householdIncome.A16-2'),
    '392_universal_data-A16-3': i18n.t('specialCondition.householdIncome.A16-3'),
    '392_universal_data-A16-4': i18n.t('specialCondition.householdIncome.A16-4'),
    '392_universal_data-A16-5': i18n.t('specialCondition.householdIncome.A16-5'),
    '392_universal_data-A16-6': i18n.t('specialCondition.householdIncome.A16-6'),
    '392_universal_data-A16-7': i18n.t('specialCondition.householdIncome.A16-7'),
    '392_universal_data-A16-8': i18n.t('specialCondition.householdIncome.A16-8'),
    '392_universal_data-A16-9': i18n.t('specialCondition.householdIncome.A16-9'),
    '392_universal_data-A16-10': i18n.t('specialCondition.householdIncome.A16-10'),
    '392_universal_data-A16-11': i18n.t('specialCondition.householdIncome.A16-11'),
    '392_universal_data-A16-12': i18n.t('specialCondition.householdIncome.A16-12'),
    '392_universal_data-A16-13': i18n.t('specialCondition.householdIncome.A16-13'),
    '392_universal_data-A16-14': i18n.t('specialCondition.householdIncome.A16-14'),
    '392_universal_data-A16-15': i18n.t('specialCondition.householdIncome.A16-15'),
    '392_universal_data-A16-16': i18n.t('specialCondition.householdIncome.A16-16'),
    '392_universal_data-A16-17': i18n.t('specialCondition.householdIncome.A16-17'),
    '392_universal_data-A16-18': i18n.t('specialCondition.householdIncome.A16-18'),
    '392_universal_data-A16-19': i18n.t('specialCondition.householdIncome.A16-19'),
    '392_universal_data-A16-20': i18n.t('specialCondition.householdIncome.A16-20'),
    '392_universal_data-A16-21': i18n.t('specialCondition.householdIncome.A16-21'),
    '392_universal_data-A16-22': i18n.t('specialCondition.householdIncome.A16-22'),
    '392_universal_data-B28-1': i18n.t('specialCondition.jobGroup.B28-1'),
    '392_universal_data-B28-2': i18n.t('specialCondition.jobGroup.B28-2'),
    '392_universal_data-B28-3': i18n.t('specialCondition.jobGroup.B28-3'),
    '392_universal_data-B28-4': i18n.t('specialCondition.jobGroup.B28-4'),
    '392_universal_data-B28-5': i18n.t('specialCondition.jobGroup.B28-5'),
    '392_universal_data-B28-6': i18n.t('specialCondition.jobGroup.B28-6'),
    '392_universal_data-B28-7': i18n.t('specialCondition.jobGroup.B28-7'),
    '392_universal_data-B28-8': i18n.t('specialCondition.jobGroup.B28-8'),
    '392_universal_data-B28-9': i18n.t('specialCondition.jobGroup.B28-9'),
    '392_universal_data-B28-10': i18n.t('specialCondition.jobGroup.B28-10'),
    '392_universal_data-B28-11': i18n.t('specialCondition.jobGroup.B28-11'),
    '392_universal_data-A5-1': i18n.t('specialCondition.marriageStatus.A5-1'),
    '392_universal_data-A5-2': i18n.t('specialCondition.marriageStatus.A5-2'),
    '392_universal_data-A6-1': i18n.t('specialCondition.childrenStatus.A6-1'),
    '392_universal_data-A6-2': i18n.t('specialCondition.childrenStatus.A6-2'),
  },
};

export const QUALIFICATION_GENDER_TYPE = {
  MALE: 1,
  FEMALE: 2,
  BOTH: 3, // 男女合算
  EACH: 4, // 男女別
};

export const QUOTA_GENDER_TYPE = {
  MALE: 1,
  FEMALE: 2,
  BOTH: 3, // 男女合算
};

export const QUALIFICATION_GENDER_TYPE_NAMES = {
  [QUALIFICATION_GENDER_TYPE.MALE]: i18n.t('quotas.conditions.gender.male'),
  [QUALIFICATION_GENDER_TYPE.FEMALE]: i18n.t('quotas.conditions.gender.female'),
  [QUALIFICATION_GENDER_TYPE.BOTH]: i18n.t('quotas.conditions.gender.both'),
  [QUALIFICATION_GENDER_TYPE.EACH]: i18n.t('quotas.conditions.gender.each'),
};

export const AGE_DIVIDE_TYPES = {
  NONE: 0,
  FIVE: 1,
  TEN: 2,
};

export const PUBLIC_HEADER_TOOLS_MASTER = [
  {
    id: 'login',
    label: 'appCommon.login',
    variant: 'outlined',
    link: ROUTES.USER.SIGNIN,
  },
  {
    id: 'signup',
    label: 'appCommon.signup',
    variant: 'outlined',
    link: ROUTES.USER.SIGNUP,
  },
  {
    id: 'adminLogin',
    label: 'appCommon.login',
    variant: 'outlined',
    link: ROUTES.ADMIN.SIGNIN,
  },
];

export const PUBLIC_HEADER_TOOL_ITEMS = {
  [ROUTES.USER.SIGNUP]: ['login'], // PUBLIC_HEADER_TOOLS_MASTERのid指定,
  [ROUTES.USER.SIGNUP_CONFIRM]: ['login'],
  [ROUTES.USER.SIGNUP_COMPLETED]: ['login'],
  [ROUTES.USER.SIGNUP_VERIFY_COMPLETED]: ['login'],
  [ROUTES.USER.PASSWORD_RESET_REQUEST]: ['login'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.USER.PASSWORD_RESET_SEND_MAIL_COMPLETED]: ['login'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.USER.PASSWORD_RESET_INPUT]: ['login'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.USER.PASSWORD_RESET_COMPLETED]: ['login'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.SIGNUP]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.SIGNUP_CONFIRM]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.SIGNUP_COMPLETED]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.SIGNUP_VERIFY_COMPLETED]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.PASSWORD_RESET_REQUEST]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.PASSWORD_RESET_SEND_MAIL_COMPLETED]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.PASSWORD_RESET_INPUT]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
  [ROUTES.ADMIN.PASSWORD_RESET_COMPLETED]: ['adminLogin'], // PUBLIC_HEADER_TOOLS_MASTERのid指定
};

export const PAYMENT_TYPE = {
  CREDIT_CARD: 1,
  INVOICE: 2,
};

export const SURVEY_TYPE = {
  GOOGLE_FORM: 1,
  ORIGINAL_FORM: 2,
};

export const SPECIAL_PANEL_CATEGORIES = {
  [SPECIAL_PANEL_DISPLAY_SETTING_IDS.V1]: [
    'jobGroup',
    'industry',
    'marriageStatus',
    'childrenStatus',
  ],
  [SPECIAL_PANEL_DISPLAY_SETTING_IDS.V2]: [
    'jobType',
    'jobGroup',
    'industry',
    'numOfWorkers',
    'jobPosition',
    'householdIncome',
    'marriageStatus',
    'childrenStatus',
  ],
};

export const COUNTRY_CDS = {
  JAPAN: '392',
};

export const DEFAULT_AGE = {
  FROM: 15,
  TO: 99,
  DIVIDE_TYPE: AGE_DIVIDE_TYPES.NONE,
};

export const REJECT_REASON_CATEGORIES = [
  { id: 1, category: i18n.t('surveyStatusModal.rejectCategory.1') },
  { id: 2, category: i18n.t('surveyStatusModal.rejectCategory.2') },
  { id: 3, category: i18n.t('surveyStatusModal.rejectCategory.3') },
  { id: 4, category: i18n.t('surveyStatusModal.rejectCategory.4') },
  { id: 5, category: i18n.t('surveyStatusModal.rejectCategory.5') },
  { id: 99, category: i18n.t('surveyStatusModal.rejectCategory.99') },
];

export const STATIC_URLS = {
  ESTIMATE_LIMIT: 'https://app.gmoask.com/help',
};

export const TEXT_MAX_LENGTH = 1000;

export const REJECT_REASON_MAX_LENGTH = 3000;

// MySQLのINT型用最大値
export const INT_MAX_VALUE = 2147483647;

export const PREFECTURE_NAMES = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

// 反社・与信チェック等で項目によってcellの色変更する可能性があるのでkeyにcellいる
export const USER_TABLE_HEAD = [
  { id: 'id', text: i18n.t('adminUsers.tableHead.id'), cell: 'normal' },
  { id: 'name', text: i18n.t('adminUsers.tableHead.name'), cell: 'normal' },
  { id: 'email', text: i18n.t('adminUsers.tableHead.email'), cell: 'normal' },
  { id: 'category', text: i18n.t('adminUsers.tableHead.category'), cell: 'normal' },
  { id: 'companyName', text: i18n.t('adminUsers.tableHead.companyName'), cell: 'normal' },
  {
    id: 'departmentName',
    text: i18n.t('adminUsers.tableHead.departmentName'),
    cell: 'normal',
  },
  { id: 'zip', text: i18n.t('adminUsers.tableHead.zip'), cell: 'normal' },
  { id: 'pref', text: i18n.t('adminUsers.tableHead.pref'), cell: 'normal' },
  { id: 'address', text: i18n.t('adminUsers.tableHead.address'), cell: 'normal' },
  { id: 'phone', text: i18n.t('adminUsers.tableHead.phone'), cell: 'normal' },
  { id: 'created', text: i18n.t('adminUsers.tableHead.created'), cell: 'normal' },
];

export const ADMINISTRATOR_TABLE_HEAD = [
  { id: 'id', text: i18n.t('administratorAndRoles.tableHead.id'), cell: 'normal' },
  { id: 'name', text: i18n.t('administratorAndRoles.tableHead.name'), cell: 'normal' },
  { id: 'email', text: i18n.t('administratorAndRoles.tableHead.email'), cell: 'normal' },
  { id: 'roles', text: i18n.t('administratorAndRoles.tableHead.roles'), cell: 'normal' },
  { id: 'action', text: i18n.t('administratorAndRoles.tableHead.action'), cell: 'normal' },
];

export const ANTISOCIAL_CHECK = {
  APPROVED: true,
  REJECTED: false,
};

export const ANTISOCIAL_CHECK_APPROVAL = {
  APPROVED: true,
  REJECTED: false,
};

export const CREDIT_CHECK = {
  APPROVED: true,
  REJECTED: false,
};

export const ANTISOCIAL_CHECK_NAME = {
  [JUDGEMENT_STATUS.UNTOUCHED]: '未',
  [JUDGEMENT_STATUS.OK]: 'OK',
  [JUDGEMENT_STATUS.NG]: 'NG',
};

export const ANTISOCIAL_CHECK_APPROVAL_NAME = {
  [JUDGEMENT_STATUS.UNTOUCHED]: '未',
  [JUDGEMENT_STATUS.OK]: '承認',
  [JUDGEMENT_STATUS.NG]: '差戻',
  [JUDGEMENT_STATUS.UNNEEDED]: '不要', // APIレスポンスには存在しないが反社チェックNGの場合にフロントで差し替える
};

export const CREDIT_CHECK_NAME = {
  [JUDGEMENT_STATUS.UNTOUCHED]: '未',
  [JUDGEMENT_STATUS.OK]: 'OK',
  [JUDGEMENT_STATUS.NG]: 'NG',
  [JUDGEMENT_STATUS.UNNEEDED]: '不要',
};

export const SURVEY_CHECK_NAME = {
  [JUDGEMENT_STATUS.UNTOUCHED]: '未',
  [JUDGEMENT_STATUS.OK]: '承認',
  [JUDGEMENT_STATUS.NG]: '差戻',
};

export const SCREEN_VISIBILITY_SETTINGS = {
  SURVEY_REGISTER_NG_CHECKLIST_HIDDEN: 'survey_regist_ng_checklist_hidden',
};

export const SCREEN_VISIBILITY_SETTINGS_IDS = {
  [SCREEN_VISIBILITY_SETTINGS.SURVEY_REGISTER_NG_CHECKLIST_HIDDEN]: 1,
};
